import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { MeasurementService } from '../../../../../services/measurement.service';

@Component({
    selector: 'app-joint-thickness',
    templateUrl: './joint-thickness.component.html',
    styleUrls: ['./joint-thickness.component.scss'],
    standalone: false
})
export class JointThicknessComponent implements OnInit {
    @Input() form: UntypedFormGroup;

    constructor(private measSvc: MeasurementService) {}

    ngOnInit(): void {
        this.form.markAllAsTouched();
        this.form
            .get('jointThickness')
            .valueChanges.subscribe((value) =>
                this.form.get('jointThickness').patchValue(this.measSvc.format(value, UnitType.DefaultLengthUnit), { emitEvent: false })
            );
    }
}
